import { useEffect, useState, useMemo, useCallback } from "react";
import { cleanText } from "../Routes/Home/Components/Chatbot/utils";

const tag = '[WeddingPlan]'

const hiddenSuggestionTag = '[SUGGESTIONS:'

const removeSuggestionTag = (rawContent) => {
  let cleaned = rawContent;
  
// Handle both cases: with and without closing tag
  cleaned = cleaned.replace(/\[SUGGESTIONS:(?:[^\]]*\]|.*)/g, '');

  // Remove [SHOW_DATE_PICKER] tag
  cleaned = cleaned.replace(/\[SHOW_DATE_PICKER\]/g, '');
  return cleaned;
}

function useStreamContent(rawStreamingContent) {
  const [streamingContent, setStreamingContent] = useState('');
  const [isParsing, setIsParsing] = useState(false);
  const [firstTagIndex, setFirstTagIndex] = useState(-1);
  const [lastTagIndex, setLastTagIndex] = useState(-1);
  
  const findTagIndex = useCallback((text, startIndex = 0) => {
    return text ? text.indexOf(tag, startIndex) : -1;
  }, []);
  
  // Memoize content to avoid unnecessary processing
  const content = useMemo(() => removeSuggestionTag(rawStreamingContent) || '', [rawStreamingContent]);
  
  useEffect(() => {
    // Reset states if content is cleared/changed significantly
    if (!content) {
      setStreamingContent('');
      setIsParsing(false);
      setFirstTagIndex(-1);
      setLastTagIndex(-1);
      return;
    }
    
    // Find tag positions
    const currentFirstTagIndex = firstTagIndex !== -1 
      ? firstTagIndex 
      : findTagIndex(content);
      
    const currentLastTagIndex = firstTagIndex !== -1 
      ? findTagIndex(content, firstTagIndex + tag.length) 
      : -1;
    
    // Case 1: No tags found yet
    if (currentFirstTagIndex === -1) {
      setStreamingContent(content);
      return;
    }
    
    // Case 2: First tag found, but not the second
    if (currentFirstTagIndex !== -1 && currentLastTagIndex === -1) {
      if (firstTagIndex === -1) {
        // We just found the first tag
        setFirstTagIndex(currentFirstTagIndex);
        setIsParsing(true);
      }
      setStreamingContent(content.slice(0, currentFirstTagIndex));
      return;
    }
    
    // Case 3: Both tags found
    if (currentFirstTagIndex !== -1 && currentLastTagIndex !== -1) {
      if (lastTagIndex === -1) {
        // We just found the second tag
        setLastTagIndex(currentLastTagIndex);
        setIsParsing(false);
      }
      setStreamingContent(
        content.slice(0, currentFirstTagIndex) + 
        content.slice(currentLastTagIndex + tag.length)
      );
      return;
    }
  }, [content, findTagIndex, firstTagIndex, lastTagIndex]);
  
  // Return the cleaned content and parsing state
  return { 
    streamingContent: useMemo(() => streamingContent, [streamingContent]), 
    isParsing 
  };
}

export default useStreamContent;
